<template>
  <v-container id="delivery-detail">
    <div class="page-title">{{$route.name}}</div>

    <v-row justify="end" class="mb-4">
      <c-btn class="mr-2" color="blue" iconName="cancel" :disabled="isCancel" outlined @click="cancelDialogOpen = true">예약취소</c-btn>
      <c-btn class="mr-6" color="grey" outlined @click="$router.go(-1)" iconName="mdi-format-list-bulleted-square">
        돌아가기
      </c-btn>
    </v-row>

    <c-card class="white" v-if="deliveryInfo">
      <fixed-delivery-detail :delivery-info="deliveryInfo" :customer-info="customerInfo"></fixed-delivery-detail>

      <div class="ml-3">
        <v-divider></v-divider>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배송 진행 상황</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            <v-menu offset-y :disabled="setStateChangeDisable">
              <template v-slot:activator="{on}">
                <v-chip dark v-on="on" :color="setStateColor">
                  {{deliveryInfo.state.configName}}
                </v-chip>
              </template>
              <v-list v-for="item in setDeliveryState">
                <v-list-item @click="onChangeDeliverAction">
                  <v-list-item-content>
                    {{item}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배정 기사</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            {{deliveryInfo.driverName ? deliveryInfo.driverName : '-'}}
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <span class="font-weight-black">배정 차량</span>
          </v-col>
          <v-col cols="12" sm="6" md="10">
            {{deliveryInfo.plateNo ? deliveryInfo.plateNo : '-'}}
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </div>

      <delivery-pay-log
          :pay-log-list="payLogList"
          :delivery-fee="deliveryFee"
          :real-fee="realFee"
          :pay-method="payMethod"
          :delivery-id="deliveryInfo.id"
          @reqUpdateDeliveryFee="reqUpdateDeliveryFee"
      ></delivery-pay-log>
    </c-card>

    <manual-delivery-dialog
        :open.sync="manualDialogOpen"
        :delivery-check-data.sync="deliveryInfo"
        :deliveryFlag.sync="isDone"
    ></manual-delivery-dialog>

    <delivery-cancel-dialog
        :open.sync="cancelDialogOpen"
        :delivery-id="id"
        @reqCancelDelivery="reqCancelDelivery"
    />
  </v-container>
</template>

<script>
import FixedDeliveryDetail from "@/views/CallTaxi/Delivery/FixedDeliveryDetail";
import DeliveryPayLog from "@/views/CallTaxi/Delivery/DeliveryPayLog";
import ManualDeliveryDialog from "@/views/CallTaxi/Delivery/ManualDeliveryDialog";
import DeliveryCancelDialog from "@/views/CallTaxi/Delivery/DeliveryCancelDialog";

export default {
  name: "DeliveryDetail",
  components:{ FixedDeliveryDetail, DeliveryPayLog, ManualDeliveryDialog, DeliveryCancelDialog },
  data() {
    return {
      id: this.$route.params.id,
      deliveryInfo : null,
      customerInfo : null,
      changeDeliveryState: false,
      payLogList: [],
      deliveryFee: 0,
      realFee: 0,
      payMethod: '-',
      manualDialogOpen: false,
      isDone: null,

      cancelDialogOpen: false,
      cancelDeliveryId: '',
    }
  },
  methods:{
    async getDetailInfo() {
      const res = await this.$api.getDetailInfo(this.id);
      this.deliveryInfo = res.data;
      this.customerInfo = res.data.customerDetailRes;
    },
    async getPaylog() {
      try {
        const res = await this.$api.getPayLog(this.$route.params.id);
        this.payLogList = res.data.deliveryPayLogList;
        this.deliveryFee = res.data.expectedFee;
        this.realFee = res.data.realFee;
        this.payMethod = res.data.payMethod;
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'getPaylog'});
      }
    },
    async reqUpdateDeliveryFee(request) {
      try {
        await this.$api.updateDeliveryFee(request);
        await this.getPaylog();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqUpdateDeliveryFee'});
      }
    },
    onChangeDeliverAction() {
      if(!this.deliveryInfo) return;
      const currentState = this.deliveryInfo.state.configValue;
      if(currentState === 'dvry_wait_assignment') {
        //배차대기상태 : 수동배차 dialog
        this.manualDialogOpen = true;
      } else if (currentState === 'dvry_to_be_done') {
        this.$store.commit('alert',
            {
              open: true, persistent: true, msg: "배차 대기 상태로 변경하시겠습니까?",
              confirm: true, callBack: () => {
                const reqDate = {
                  id: this.deliveryInfo.id,
                  deliveryState: 'dvry_wait_assignment'
                };
                this.reqUpdateDeliveryState(reqDate);
              }
            });
      } else if (currentState === 'dvry_user_cancel') {
        this.changeCancelType(2);
      } else if (currentState === 'dvry_admin_cancel') {
        this.changeCancelType(1);
      }
      this.getDetailInfo();
    },
    async reqUpdateDeliveryState(data) {
      try {
        await this.$api.updateDeliveryState(data);
        await this.getDetailInfo();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqUpdateDeliveryState'});
      }
    },
    async reqCancelDelivery(data) {
      try {
        await this.$api.cancelDelivery(data);
        await this.getDetailInfo();
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqCancelDelivery'});
      }
    },
    changeCancelType(type) {
      // 1: 무단취소, 2: 정상취소
      const deliveryState = (type === 1) ? 'dvry_user_cancel' : 'dvry_admin_cancel';
      const reqParam = {
        id: this.id,
        deliveryState: deliveryState
      };
      this.reqCancelDelivery(reqParam);
    },
  },
  mounted() {
    this.getDetailInfo();
    this.getPaylog();
  },
  computed: {
    setStateChangeDisable() {
      return this.deliveryInfo && this.deliveryInfo.state.configValue ==='dvry_done'
    },
    setDeliveryState() {
      if(!this.deliveryInfo) return;
      const currentState = this.deliveryInfo.state.configValue;
      if(currentState === 'dvry_wait_assignment') {
        return ['수동배차'];
      } else if(currentState === 'dvry_to_be_done') {
        return ['배차취소'];
      } else if(currentState === 'dvry_admin_cancel') {
        return ['무단취소'];
      } else if(currentState === 'dvry_user_cancel') {
        return ['정상취소'];
      }
      return;
    },
    setStateColor() {
      const currentState = this.deliveryInfo.state.configValue;
      if (currentState === 'dvry_wait_assignment') {
        return 'light1Red';
      } else if (currentState === 'dvry_to_be_done') {
        return 'light1Green';
      } else if (currentState === 'dvry_done') {
        return 'light2Blue';
      } else if (currentState === 'dvry_user_cancel') {
        return 'red';
      } else if (currentState === 'dvry_admin_cancel') {
        return 'light2Grey';
      } else {
        return 'light1Grey';
      }
    },
    isCancel() {
      if (this.deliveryInfo) {
        return !(this.deliveryInfo.state.configValue === 'dvry_to_be_done' || this.deliveryInfo.state.configValue === 'dvry_wait_assignment');
      }
    }
  },
  watch: {
    isDone(value) {
      if(value && value === 'success') {
        this.getDetailInfo();
      }
    }
  }
}
</script>

<style scoped>

</style>